import {$} from './jquery-definition.js';
import Cookies from 'js-cookie';

$( function() {
	$( '.adjacent' ).prev().addClass( 'adjacent-next' );

	$( '.modal' ).appendTo( 'body' );

	var $topBanner = $( '.top-banner' );
	if ( $topBanner.length && !Cookies.get( 'odontia-closed-top-banner' ) ) {
		$topBanner.addClass( 'active' );

		$( '.navbar' ).css( {
			'top': $topBanner.outerHeight() - 15
		} );
	} else {
		$( '.top-banner' ).removeClass( 'active' ).hide();
		$( 'body' ).removeClass( 'active-top-banner' ).removeClass( 'active-info-bubble' );

		$( '.navbar' ).css( {
			'top': 0
		} );
	}

	$( '.close-top-banner' ).on( 'click', function( clickEvent ) {
		clickEvent.preventDefault();

		$( '.top-banner' ).removeClass( 'active' ).hide();
		$( 'body' ).removeClass( 'active-top-banner' ).removeClass( 'active-info-bubble' );

		$( '.navbar' ).css( {
			'top': 0
		} );

		Cookies.set( 'odontia-closed-top-banner', true, { expires: 1 } );
	} );

	updateInitWidthContainer();

	if ( $( window ).width() < 992 ) {
		$( '.mobile-full-height-banner' ).css( {
			'height': $( window ).height() - $( '.main-banner-wrp + .container' ).height() - $( '.mobile-header-arc' ).outerHeight()
		} );
	} else {
		$( '.mobile-full-height-banner' ).css( {
			'height': 'auto'
		} )
	}
} );

$( window ).on( 'resize', function() {
	updateInitWidthContainer();
} );


$( document ).on( 'scroll', function() {
} );

export function updateInitWidthContainer() {
	setTimeout( function() {
		$( '.init-width-container' ).each( function() {
			var $this = $( this );
			var width = 0;

			$this.find( '.init-width-text' ).each( function() {
				var $this = $( this );

				width += $this.outerWidth( true );
			} );

			if ( width > 290 ) {
				$this.find( '.collapse' ).css( {
					'width': width + 'px'
				} );
			}
		} );
	}, 100 );
}
